import { render, staticRenderFns } from "./LearningRequest.vue?vue&type=template&id=7dec5588&"
import script from "./LearningRequest.vue?vue&type=script&lang=ts&"
export * from "./LearningRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports